import type React from 'react'

export interface StatItem {
  readonly label: string
  readonly value: string
  readonly hint?: string
  readonly icon: React.ReactNode
}

export interface StatsRowProps {
  readonly stats: readonly StatItem[]
}

function StatCard({ label, value, hint, icon }: StatItem): React.ReactElement {
  return (
    <div
      className="rounded-base border border-border bg-surface-elevated px-5 py-4"
      data-testid="stat-card"
    >
      <div className="flex items-start justify-between gap-2">
        <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          {label}
        </span>
        <span className="text-muted-foreground">{icon}</span>
      </div>
      <div className="mt-2 font-serif text-3xl text-foreground">{value}</div>
      {hint && (
        <div className="mt-1 text-xs text-muted-foreground" data-testid="stat-hint">
          {hint}
        </div>
      )}
    </div>
  )
}

export function StatsRow({ stats }: StatsRowProps): React.ReactElement {
  return (
    <div className="grid grid-cols-1 gap-4 pb-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="stats-row">
      {stats.map((s) => (
        <StatCard key={s.label} {...s} />
      ))}
    </div>
  )
}
